import { z } from "zod/v4";

import {
  CreateOrganizationAgencyLinkDtoSchema,
  OrganizationAgencyLinkDtoSchema,
} from "../../../dtos/organization-agency-links";
import { StripeProductVersionList } from "../../../schemas/stripe";

export const CreateOrganizationAgencyLinkRequestBodySchema = z.object({
  organizationAgencyLink: CreateOrganizationAgencyLinkDtoSchema,
});

export type CreateOrganizationAgencyLinkRequestBodyType = z.infer<
  typeof CreateOrganizationAgencyLinkRequestBodySchema
>;

export const CreateOrganizationAgencyLinkResponseBodySchema = z.object({
  organizationAgencyLink: OrganizationAgencyLinkDtoSchema,
});

export type CreateOrganizationAgencyLinkResponseBodyType = z.infer<
  typeof CreateOrganizationAgencyLinkResponseBodySchema
>;
